import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import clsx from 'clsx';
import selectors from './selectors';
import actions from './actions';
import ShiftTradeCheckoutSummary from './ShiftTradeCheckoutSummary';
import EquipmentFinanceCheckoutSummary from './EquipmentFinanceCheckoutSummary';

const useStyles: any = makeStyles((theme: any) => ({
  checkOutSummaryAlertContainer: {
    padding: theme.spacing(1, 2, 0),
  },
  checkOutSummaryData: {
    fontWeight: 500,
  },
  checkOutSummaryPanel: {
    borderRadius: '4px 4px 0 0',
    margin: theme.spacing(1.5, 3),
  },
}));

interface Props {
  noMargin?: boolean;
}

const CheckOutSummary = (props: Props) => {
  const { noMargin = false } = props;
  const classes = useStyles();
  const history = useHistory();
  const checkOut = useSelector(selectors.selectCheckOut);
  const checkOutId = useSelector(selectors.selectCheckOutId);
  const [stateCheckOut, setCheckOutState] = useState(checkOut);
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (checkOutId && (!stateCheckOut || !stateCheckOut.amount)) {
      dispatch(actions.getCheckOutSummary(checkOutId)).then((response: any) => {
        const { payload, error } = response;
        if (!error && payload.data) {
          setCheckOutState(payload.data);
        } else if (payload && payload.response && payload.response.data && payload.response.data.code == 2502) {
          history.push({
            pathname: '/500',
            state: { message: payload.response.data.message },
          });
        } else {
          history.push({
            pathname: '/500',
            state: { message: 'Sorry, this link is no longer valid' },
          });
        }
      });
    } else if (!checkOut) {
      history.push({
        pathname: '/500',
        state: { message: 'Sorry, this link is no longer valid' },
      });
    }
  }, [checkOutId]);

  return (
    <>
      {stateCheckOut && (
        <Grid className={clsx({ [classes.checkOutSummaryPanel]: !noMargin })}>
          {stateCheckOut.productCode === 'ST' && <ShiftTradeCheckoutSummary checkout={stateCheckOut} />}
          {stateCheckOut.productCode === 'EF' && <EquipmentFinanceCheckoutSummary checkout={stateCheckOut} />}
        </Grid>
      )}
    </>
  );
};

export default CheckOutSummary;
